import { useTranslation } from 'react-i18next'
import { Button } from '@dorixona/ui'

export interface LoginCtaProps {
  onSignIn: () => void
}

/** Что гость видит вместо карты лояльности. */
export function LoginCta({ onSignIn }: LoginCtaProps) {
  const { t } = useTranslation('home')

  return (
    <div className="login-cta">
      <div className="t1">{t('cta.title')}</div>
      <div className="t2">{t('cta.body')}</div>
      <div className="lc-btnrow">
        <Button onPress={onSignIn}>{t('cta.action')}</Button>
      </div>
    </div>
  )
}
